import axios from '../axios'
// 登录
export const login = data => {
  return axios({
    url: '/api/sys/login',
    method: 'post',
    data
  })
}
// 项目公司列表
export const getSysCompanyPage = data => {
  return axios({
    url: '/api/sys/getSysCompanyPage',
    method: 'post',
    data
  })
}
// 手机号登录接口
export const loginMobile = data => {
  return axios({
    url: '/api/sys/loginMobile',
    method: 'post',
    data
  })
}
// 注销
export const out = data => {
  return axios({
    url: '/api/sys/logout',
    method: 'post',
    data
  })
}

// 根据id获取T+用户信息
export const getTplusUserInfoById = data => {
  return axios({
    url: '/api/sys/getTplusUserInfoById',
    method: 'post',
    data
  })
}
// T+登录接口 去掉token
export const loginTplus = data => {
  return axios({
    url: '/api/sys/loginTplus',
    method: 'post',
    data
  })
}
// 获取所属单位下拉数据
export const getSysUserAreaListByUserName = data => {
  return axios({
    url: '/api/sys/sys/user/area/getSysUserAreaListByUserName',
    method: 'post',
    data
  })
}
// 获取默认登录组织
export const getSysUserByUserName = data => {
  return axios({
    url: '/api/sys/sys/user/area/getSysUserByUserName',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/login.js